<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" @click="goBackBtn">
      <Icon class="back_icon" type="ios-arrow-back"/>
      <span class="back_txt">{{ $t('key1002627') }}</span>
    </div>
    <!--基本信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1000929') }}</h2>
        </template>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item" v-for="(item, index) in basicInfoList" :key="index">
            <span class="basic_title">{{ item.name }}</span>
            <span class="basic_txt">{{ detailsData[item.paramsKey] }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--账单明细-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1003610') }}</h2>
        </template>
        <div class="mt10 mb10 flex align-items-center justify-content-between">
          <local-tabButton :tabButtonList="costTypeList" @selectStatus="costTypeBtn"></local-tabButton>
          <Checkbox v-if="pageParams.type === 11" :true-value="1" :false-value="0" @on-change="checkChange"
            v-model="pageParams.chooseType">{{ $t('key1003719') }}
          </Checkbox>
          <p v-if="getPermission('ymsBillPackageDetail_insertYmsBillPackageDetail') &&
           pageParams.type !== 11 && detailsData.status === 1" class="font-size-14 cursor themeColor"
            @click="initModifyInfoData('add')">{{ $t('key1003774') }}</p>
        </div>
        <div class="table_box">
          <Table
            highlight-row
            border
            max-height="500"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="tableData">
          </Table>
          <div class="flex align-items-center justify-content-between font-size-12">
            <p class="flex align-items-center">
              <span>{{ $t('key1003721') }}</span>
              <span :class="payoffAmount < 0 ? 'crimsonRedColor' : ''">{{ payoffAmountTotal }}</span>
            </p>
            <Page
              :transfer="true"
              v-if="!tableLoading"
              :total="total"
              @on-change="changePage"
              show-total
              :page-size="pageParams.pageSize"
              show-elevator
              :current="pageParams.pageNum"
              show-sizer
              @on-page-size-change="changePageSize"
              placement="top"
              :page-size-opts="pageArray">
            </Page>
          </div>
        </div>
      </Card>
    </div>
    <!--操作按钮-->
    <div class="options_content">
      <Button class="mr15" type="primary" v-if="detailsData.status === 1 && getPermission('ymsBill_confirmWarehouseSettlement')"
        @click="confirmSettlementBtn">{{ $t('key1002019') }}</Button>
    </div>
    <!--修改费用、添加费用、添加备注弹窗-->
    <Modal v-model="modifyInfoModal" :title="modifyInfoTitle" width="500"
      :transfer="false" :mask-closable="false" @on-visible-change="modifyInfoChange">
      <Form ref="modifyInfoForm" :model="modifyInfoForm" :rules="ruleValidates" :label-width="100" @submit.native.prevent>
        <Row style="width: 90%;">
          <!--单据费用-修改费用-->
          <template v-if="modifyInfoType === 'edit'">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1003745')" prop="packageHandlerCost">
                <InputNumber
                  class="wid100P"
                  :min="0"
                  :max="9999999"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="modifyInfoForm.packageHandlerCost">
                </InputNumber>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1003746')" prop="packageMaterialCost" class="resetStyle">
                <InputNumber
                  class="wid100P"
                  :min="0"
                  :max="9999999"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="modifyInfoForm.packageMaterialCost">
                </InputNumber>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1003747')" prop="additionalServiceCost">
                <InputNumber
                  class="wid100P"
                  :min="0"
                  :max="9999999"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="modifyInfoForm.additionalServiceCost">
                </InputNumber>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1003748')" prop="packageReturnHandlerCost">
                <InputNumber
                  class="wid100P"
                  :min="0"
                  :max="9999999"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="modifyInfoForm.packageReturnHandlerCost">
                </InputNumber>
              </FormItem>
            </Col>
          </template>
          <!--其他费用--添加、修改费用-->
          <template v-if="['add', 'update'].includes(modifyInfoType)">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1003772')" prop="businessId">
                <Input v-model.trim="modifyInfoForm.businessId"></Input>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1003773')" prop="feeAmount">
                <InputNumber
                  class="wid100P"
                  :min="0"
                  :max="9999999"
                  :formatter="(value) => formatterNumber(value, 2)"
                  v-model.trim="modifyInfoForm.feeAmount">
                </InputNumber>
              </FormItem>
            </Col>
          </template>
          <!--添加备注-->
          <template v-if="modifyInfoType === 'remark'">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1001495')" prop="remark" :label-width="80">
                <Input
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 6}"
                  v-model.trim="modifyInfoForm.remark">
                </Input>
              </Form-item>
            </Col>
          </template>
        </Row>
      </Form>
      <template #footer>
        <Button @click="modifyInfoModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="modifyInfoBtn">{{ $t('key1000555') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {formatterNumber, getAllUsersInfo, getDataSetBatchList, getEnumName, getUserNameByUserId} from "@/utils/common";

export default {
  name: "warehouseBillDetails",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      ItemCol: 6,
      pageParams: {
        chooseType: 0,
        type: 11,
        ymsBillId: null,
        pageNum: 1,
        pageSize: 15
      },
      basicInfoList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003685'), paramsKey: 'billNo'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003593'), paramsKey: 'billTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003686'), paramsKey: 'updatedTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003744'), paramsKey: 'packageQuantity'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003745'), paramsKey: 'packageHandlerCost'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003746'), paramsKey: 'packageMaterialCost'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003747'), paramsKey: 'additionalServiceCost'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003748'), paramsKey: 'packageReturnHandlerCost'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002441'), paramsKey: 'warehouseCost'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003749'), paramsKey: 'totalPrice'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003750'), paramsKey: 'actuallyAmount'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003751'), paramsKey: 'otherCost'},
      ], // 基本信息的基础数据
      detailsData: {},
      unreconciledOrderQuantity: 0,
      originalColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003752'),
          key: 'businessId',
          minWidth: 140,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003753'),
          key: 'amount',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.amount);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003754'),
          key: 'documentNumber',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let documentNumber = '';
            if (v.pageParams.type === 11) {
              let ymsPackageInfo = params.row.ymsPackageInfo;
              if (ymsPackageInfo) {
                documentNumber = ymsPackageInfo.packageCode;
              }
            } else {
              documentNumber = params.row.businessId;
            }
            return h('span', documentNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003173'),
          key: 'merchantId',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002917'),
          key: 'status',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let ymsPackageInfo = params.row.ymsPackageInfo;
            if (ymsPackageInfo) {
              let status = ymsPackageInfo.status;
              let text = getEnumName(this.enumData, 'YmsPackageInfoStatusCoreEnum', status);
              return h('span', text);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003755'),
          key: 'quantity',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let quantity = '-';
            let ymsPackageInfo = params.row.ymsPackageInfo;
            if (ymsPackageInfo) {
              quantity = ymsPackageInfo.productQuantity;
              return h('span', quantity);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001213'),
          key: 'packageHandlerCost',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.packageHandlerCost);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003756'),
          key: 'packageMaterialCost',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.packageMaterialCost);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003757'),
          key: 'additionalServiceCost',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.additionalServiceCost);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003758'),
          key: 'packageReturnHandlerCost',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.packageReturnHandlerCost);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003759'),
          key: 'amountTo',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let packageReturnHandlerCost = params.row.packageReturnHandlerCost || 0;
            let additionalServiceCost = params.row.additionalServiceCost || 0;
            let packageMaterialCost = params.row.packageMaterialCost || 0;
            let packageHandlerCost = params.row.packageHandlerCost || 0;
            let amountTo = packageReturnHandlerCost + additionalServiceCost + packageMaterialCost + packageHandlerCost;
            let text = v.formatCurrency(amountTo);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003760'),
          key: 'actuallyAmount',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let ymsPackageInfo = params.row.ymsPackageInfo;
            if (ymsPackageInfo) {
              let ymsPackageCostList = ymsPackageInfo.ymsPackageCostList || [];
              let totalAmount = ymsPackageCostList.reduce((total, item) => total + item.amount, 0);
              return h('span', v.formatCurrency(totalAmount) + ' ' + currency);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003705'),
          key: 'profitAndLoss',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let totalAmount = 0;
            let ymsPackageInfo = params.row.ymsPackageInfo;
            if (ymsPackageInfo) {
              let ymsPackageCostList = ymsPackageInfo.ymsPackageCostList || [];
              totalAmount = ymsPackageCostList.reduce((total, item) => total + item.amount, 0);
            }
            let currency = params.row.currency || v.currencyState;
            let packageReturnHandlerCost = params.row.packageReturnHandlerCost || 0;
            let additionalServiceCost = params.row.additionalServiceCost || 0;
            let packageMaterialCost = params.row.packageMaterialCost || 0;
            let packageHandlerCost = params.row.packageHandlerCost || 0;
            let amountTo = packageReturnHandlerCost + additionalServiceCost + packageMaterialCost + packageHandlerCost;
            let profitAndLoss = totalAmount - amountTo;
            return h('span', {class: profitAndLoss < 0 ? 'crimsonRedColor' : ''},
              (profitAndLoss > 0 ? '+ ' + v.formatCurrency(profitAndLoss) : v.formatCurrency(profitAndLoss)) + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350'),
          key: 'remark',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            return v.checkContentOverflow(h, params.row.remark, 150, 2);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003761'),
          key: 'createdTime',
          minWidth: 170,
          align: 'center',
          render: (h, params) => {
            if (v.pageParams.type === 11) {
              let ymsPackageInfo = params.row.ymsPackageInfo;
              if (ymsPackageInfo) {
                let shipedTime = ymsPackageInfo.shipedTime;
                return h('div', v.$uDate.dealTime(shipedTime, 'fulltime'));
              }
            } else {
              return h('div', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003707'),
          key: 'source',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let text = '-';
            let source = params.row.source;
            let updatedBy = getUserNameByUserId(params.row.updatedBy, v.userInfoList);
            let createdBy = getUserNameByUserId(params.row.createdBy, v.userInfoList);
            switch (source) {
              case 0:
                text = createdBy;
                break;
              case null:
                text = updatedBy;
                break;
              case 1:
                text = createdBy + ' ' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003708');
                break;
              case 2:
                text = updatedBy + ' ' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002016');
                break;
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'left',
          width: 150,
          fixed: 'right',
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003762'),
                    show: v.getPermission('ymsBillPackageDetail_updateWarehouseYmsBillPackageDetail'),
                    clickFn: () => {
                      let type = v.pageParams.type === 11 ? 'edit' : 'update';
                      v.initModifyInfoData(type, params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002015'),
                    show: v.getPermission('ymsBillPackageDetail_insertWarehouseRemarks'),
                    clickFn: () => {
                      v.initModifyInfoData('remark', params.row);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableColumns: [],
      tableData: [],
      total: 0,
      costTypeList: [
        {selected: true, value: 11, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003763')},
        {selected: false, value: 12, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003764')}
      ],
      modifyInfoModal: false,
      modifyInfoTitle: '',
      modifyInfoForm: {
        remark: '',
        feeAmount: null,
        businessId: '',
        additionalServiceCost: null,
        packageHandlerCost: null,
        packageMaterialCost: null,
        packageReturnHandlerCost: null,
      },
      ruleValidates: {
        packageHandlerCost: [
          {required: true, type: 'number', message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003765'), trigger: 'change'}
        ],
        feeAmount: [
          {required: true, type: 'number', message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003766'), trigger: 'change'}
        ],
        businessId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003767'), trigger: 'blur'}
        ],
        remark: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003710'), trigger: 'blur'}
        ],
      },
      modifyInfoType: 'add',
      ymsBillId: null,
      modifyInfo: {},
      payoffAmount: 0,
      userInfoList: {},
      enumData: [],
    };
  },
  computed: {
    // 处理盈亏数据
    payoffAmountTotal() {
      let payoffAmount = (this.payoffAmount > 0 ? ('+' + this.formatCurrency(this.payoffAmount)) :
        this.formatCurrency(this.payoffAmount)) + ' ' + this.currencyState;
      let txt = payoffAmount;
      return txt;
    },
  },
  created() {
    this.ymsBillId = this.$route.query.ymsBillId;
    this.initWarehouseBillDetails();
  },
  methods: {
    formatterNumber,
    // 初始化数据
    initWarehouseBillDetails() {
      (async () => {
        let enumKeyList = ['YmsPackageInfoStatusCoreEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
        });
        await this.costTypeBtn(0, 11);
      })();
    },
    // 返回列表
    goBackBtn() {
      this.$router.push('/warehouseBill');
    },
    // 获取仓储账单详情数据
    getWarehouseBillDetailsData() {
      let v = this;
      v.detailsData = {};
      v.axios.get(api.get_ymsBill_warehouseBill + v.ymsBillId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            if (data.billMonth) {
              let time = data.billMonth.split('-');
              data.billTime = `${time[0]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000492')}${time[1]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000493')}`;
            }
            data['updatedTime'] = v.$uDate.dealTime(data.updatedTime, 'fulltime');
            let ymsBillPackageDetailList = data.ymsBillPackageDetailList || [];
            if (ymsBillPackageDetailList.length > 0) {
              const totalOtherCost = ymsBillPackageDetailList.reduce((accumulator, currentItem) => {
                if (currentItem.type === 12) {
                  return accumulator + currentItem.amount;
                } else {
                  return accumulator;
                }
              }, 0);
              data.otherCost = totalOtherCost;
            }
            let costKeyList = [
              'packageHandlerCost',
              'packageMaterialCost',
              'additionalServiceCost',
              'packageReturnHandlerCost',
              'warehouseCost',
              'totalPrice',
              'actuallyAmount',
              'otherCost',
            ];
            costKeyList.map((key) => {
              data[key] = v.formatCurrency(data[key]) + ' ' + data.currency;
            });
            v.detailsData = data;
            v.handleColumns(v.pageParams.type);
          }
        }
      });
    },
    // 列表查询的方法
    getWarehouseBillDetailsList() {
      let v = this;
      v.optionBtnWidth = [];
      v.tableData = [];
      v.total = 0;
      v.tableLoading = true;
      let query = Object.assign({}, v.pageParams);
      query.ymsBillId = v.ymsBillId;
      v.axios.post(api.post_ymsBillPackageDetail_queryWarehouseBillPackageDetail, query).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let list = data.list || [];
            if (list.length > 0) {
              v.tableData = list;
              v.updateTableDom('selection');
            }
          }
          v.total = data.total;
        }
      });
    },
    // 确认结算
    confirmSettlementBtn() {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003711'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003712'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002019'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsBill_confirmWarehouseSettlement + v.ymsBillId, null,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003713'));
              v.initWarehouseBillDetails();
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 选取订单状态
    costTypeBtn(index, value) {
      let v = this;
      v.pageParams.type = value;
      v.costTypeList.forEach((n, i) => {
        n.selected = i === index;
      });
      v.getPhaseData();
      v.getWarehouseBillDetailsData();
      v.pageParamsStatus = true;
    },
    // 处理列表字段
    handleColumns(val) {
      let v = this;
      v.optionBtnWidth = [];
      let hideKeyColumns = [];
      let obj = {
        '11': ['businessId', 'amount'],
        '12': [
          'documentNumber',
          'merchantId',
          'status',
          'quantity',
          'packageHandlerCost',
          'packageMaterialCost',
          'additionalServiceCost',
          'packageReturnHandlerCost',
          'amountTo',
          'actuallyAmount',
          'profitAndLoss'
        ]
      };
      hideKeyColumns = obj[val] || [];
      if (v.detailsData.status === 2) {
        hideKeyColumns = [...hideKeyColumns, 'options'];
      }
      v.tableColumns = v.originalColumns.filter((item) => {
        return !hideKeyColumns.includes(item.key);
      });
      v.updateTableDom('selection');
    },
    // 初始化弹窗
    initModifyInfoData(type, data) {
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003768'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003762'),
        remark: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002015'),
        update: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003762')
      };
      this.modifyInfoTitle = obj[type];
      this.modifyInfoType = type;
      this.modifyInfo = data;
      if (data) {
        let keyList = [];
        if (type === 'edit') {
          keyList = [
            'additionalServiceCost',
            'packageHandlerCost',
            'packageMaterialCost',
            'packageReturnHandlerCost'
          ];
        } else if (type === 'update') {
          keyList = ['businessId', 'feeAmount'];
        }
        keyList.map((key) => {
          if (key === 'feeAmount') {
            this.modifyInfoForm[key] = data['amount'];
          } else {
            this.modifyInfoForm[key] = data[key];
          }
        });
      }
      this.modifyInfoModal = true;
    },
    // 保存按钮
    modifyInfoBtn() {
      let v = this;
      let url = '';
      let text = '';
      let query = {};
      let obj = JSON.parse(JSON.stringify(v.modifyInfoForm));
      switch (v.modifyInfoType) {
        case 'add':
          url = api.post_ymsBillPackageDetail_insertYmsBillPackageDetail;
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003769');
          query = {
            amount: obj.feeAmount,
            businessId: obj.businessId,
            ymsBillId: v.ymsBillId
          };
          break;
        case 'edit':
          url = api.post_ymsBillPackageDetail_updateWarehouseYmsBillPackageDetail;
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003770');
          query = {
            additionalServiceCost: obj.additionalServiceCost,
            packageHandlerCost: obj.packageHandlerCost,
            packageMaterialCost: obj.packageMaterialCost,
            packageReturnHandlerCost: obj.packageReturnHandlerCost,
            ymsBillPackageDetailId: v.modifyInfo.ymsBillPackageDetailId,
            type: v.pageParams.type
          };
          break;
        case 'update':
          url = api.post_ymsBillPackageDetail_updateWarehouseYmsBillPackageDetail;
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003770');
          query = {
            type: v.pageParams.type,
            businessId: obj.businessId,
            amount: obj.feeAmount,
            ymsBillPackageDetailId: v.modifyInfo.ymsBillPackageDetailId,
          };
          break;
        case 'remark':
          url = api.post_ymsBillPackageDetail_insertWarehouseRemarks;
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003771');
          query = {
            remark: obj.remark,
            ymsBillId: v.ymsBillId,
            ymsBillPackageDetailId: v.modifyInfo.ymsBillPackageDetailId
          };
          break;
      }
      v.$refs['modifyInfoForm'].validate((valid) => {
        if (valid) {
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.costAllocationModal = false;
              v.$Message.success(text);
              if (v.modifyInfoType !== 'remark') {
                v.getWarehouseBillDetailsData();
                v.getPhaseData();
              }
              v.modifyInfoModal = false;
              v.pageParamsStatus = true;
            }
          });
        }
      });
    },
    // 切换订单
    checkChange() {
      this.pageParamsStatus = true;
      this.getPhaseData();
    },
    // 获取盈亏数据
    getPhaseData() {
      let v = this;
      let query = {
        chooseType: v.pageParams.chooseType,
        type: v.pageParams.type,
        ymsBillId: v.ymsBillId,
      };
      v.payoffAmount = 0;
      v.axios.post(api.post_ymsBillPackageDetail_queryWarehouseYmsBillPayoffAmount, query,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.payoffAmount = data;
          }
        }
      });
    },
    // 监听弹窗
    modifyInfoChange(value) {
      if (!value) {
        this.modifyInfoForm = {
          remark: '',
          feeAmount: null,
          businessId: '',
          additionalServiceCost: null,
          packageHandlerCost: null,
          packageMaterialCost: null,
          packageReturnHandlerCost: null,
        };
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getWarehouseBillDetailsList();
        v.pageParamsStatus = false;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.details_box_styles .options_content {
  position: fixed;
  min-width: 100%;
  z-index: 10;
  background-color: #fff;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 15px;
  box-shadow: 0 -1px 7px rgb(0 0 0 / 15%);
}

/deep/ .resetStyle .ivu-form-item-label:before {
  content: ' ' !important;
}
</style>
